/**
 * Party
 * iMIS Party API
 *
 * OpenAPI spec version: 20.3.44
 * Contact: support@advsol.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenericPropertyData } from './genericPropertyData';


/**
 * A collection of generic properties.
 */
export class GenericPropertyDataCollection { 
    /**
     * The DataType must be \"Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts\"
     */
    $type = 'Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts';
    /**
     * The values for the collection
     */
    $values = new Array<GenericPropertyData>();
}
